var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTractor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2146_13155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.909 23.8636C26.2855 23.8636 26.5908 23.5584 26.5908 23.1818C26.5908 22.8053 26.2855 22.5 25.909 22.5C25.5324 22.5 25.2272 22.8053 25.2272 23.1818C25.2272 23.5584 25.5324 23.8636 25.909 23.8636Z",
    fill: "url(#paint0_linear_2146_13155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13636 15.6816C2.72727 15.6816 0 18.4089 0 21.818C0 25.2271 2.72727 27.9544 6.13636 27.9544C9.54545 27.9544 12.2727 25.2271 12.2727 21.818C12.2727 18.4089 9.54545 15.6816 6.13636 15.6816ZM6.13636 26.5907C3.47727 26.5907 1.36364 24.4771 1.36364 21.818C1.36364 19.1589 3.47727 17.0453 6.13636 17.0453C8.79545 17.0453 10.9091 19.1589 10.9091 21.818C10.9091 24.4771 8.79545 26.5907 6.13636 26.5907Z",
    fill: "url(#paint1_linear_2146_13155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13633 19.0898C4.63633 19.0898 3.40906 20.3171 3.40906 21.8171C3.40906 23.3171 4.63633 24.5444 6.13633 24.5444C7.63633 24.5444 8.8636 23.3171 8.8636 21.8171C8.8636 20.3171 7.63633 19.0898 6.13633 19.0898ZM6.13633 23.1808C5.38633 23.1808 4.77269 22.5671 4.77269 21.8171C4.77269 21.0671 5.38633 20.4535 6.13633 20.4535C6.88633 20.4535 7.49997 21.0671 7.49997 21.8171C7.49997 22.5671 6.88633 23.1808 6.13633 23.1808Z",
    fill: "url(#paint2_linear_2146_13155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.909 19.0895C25.5681 19.0895 25.2272 19.1577 24.9545 19.2259L24.5454 18.8849C22.0908 16.8395 18.8863 15.6804 15.6817 15.6804C15.2726 15.6804 14.9999 15.9531 14.9999 16.3622C14.9999 16.7713 15.2726 17.044 15.6817 17.044C18.5454 17.044 21.3408 18.0668 23.5226 19.8395C22.6363 20.4531 22.0226 21.4077 21.8181 22.4986H21.7499H14.9999C14.9999 22.294 14.9999 22.0213 14.9999 21.8168C14.9999 16.9077 11.0454 12.9531 6.13628 12.9531C3.95446 12.9531 1.84083 13.7713 0.204463 15.2031C-0.0682643 15.4759 -0.0682643 15.8849 0.136281 16.1577C0.409009 16.4304 0.818099 16.4304 1.09083 16.2259C2.52265 14.9986 4.29537 14.3168 6.13628 14.3168C10.2954 14.3168 13.6363 17.6577 13.6363 21.8168C13.6363 22.2259 13.5681 22.6349 13.4999 23.044C13.4999 23.2486 13.4999 23.4531 13.6363 23.5895C13.7726 23.7259 13.9772 23.8622 14.1817 23.8622H21.8181H21.8863C22.2272 25.7713 23.8636 27.2713 25.909 27.2713C28.159 27.2713 29.9999 25.4304 29.9999 23.1804C29.9999 20.9304 28.159 19.0895 25.909 19.0895ZM25.909 25.9077C24.409 25.9077 23.1817 24.6804 23.1817 23.1804C23.1817 21.6804 24.409 20.4531 25.909 20.4531C27.409 20.4531 28.6363 21.6804 28.6363 23.1804C28.6363 24.6804 27.409 25.9077 25.909 25.9077Z",
    fill: "url(#paint3_linear_2146_13155)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04547 12.954C2.45456 12.954 2.72728 12.6813 2.72728 12.2722V5.45401C2.72728 5.04492 3.00001 4.77219 3.4091 4.77219H6.81819V10.9086C6.81819 11.3176 7.09092 11.5904 7.50001 11.5904C7.9091 11.5904 8.18183 11.3176 8.18183 10.9086V4.77219H12C12.2727 4.77219 12.5455 4.97674 12.6136 5.24947L14.25 10.2267C13.8409 11.3176 13.0909 12.2722 12.1364 12.954L11.8636 13.0904C11.5227 13.2949 11.4546 13.704 11.6591 14.0449C11.8636 14.3858 12.2727 14.454 12.6136 14.2495L12.8864 14.1131C14.0455 13.3631 14.9318 12.2722 15.4773 10.9767H27.2727C27.6818 10.9767 27.9546 11.2495 27.9546 11.6586V12.3404H25.2273C24.8182 12.3404 24.5455 12.6131 24.5455 13.0222C24.5455 13.4313 24.8182 13.704 25.2273 13.704H27.9546V14.3858H25.2273C24.8182 14.3858 24.5455 14.6586 24.5455 15.0676C24.5455 15.4767 24.8182 15.7495 25.2273 15.7495H27.9546V16.4313H25.2273C24.8182 16.4313 24.5455 16.704 24.5455 17.1131C24.5455 17.5222 24.8182 17.7949 25.2273 17.7949H27.9546C27.9546 18.204 28.2273 18.4767 28.6364 18.4767C29.0455 18.4767 29.3182 18.204 29.3182 17.7949V11.6586C29.3182 10.4995 28.4318 9.6131 27.2727 9.6131H25.2273V4.09038C25.2273 2.93129 24.3409 2.04492 23.1818 2.04492H22.5C22.0909 2.04492 21.8182 2.31765 21.8182 2.72674C21.8182 3.13583 22.0909 3.40856 22.5 3.40856H23.1818C23.5909 3.40856 23.8636 3.68129 23.8636 4.09038V9.54492H15.4773L13.9091 4.84038C13.6364 3.95401 12.8864 3.40856 12 3.40856H3.4091C2.25001 3.40856 1.36365 4.29492 1.36365 5.45401V12.2722C1.36365 12.6813 1.63637 12.954 2.04547 12.954Z",
    fill: "url(#paint4_linear_2146_13155)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13155",
    x1: 25.909,
    y1: 22.5,
    x2: 25.909,
    y2: 23.8636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_13155",
    x1: 6.13636,
    y1: 15.6816,
    x2: 6.13636,
    y2: 27.9544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_13155",
    x1: 6.13633,
    y1: 19.0898,
    x2: 6.13633,
    y2: 24.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2146_13155",
    x1: 14.9952,
    y1: 12.9531,
    x2: 14.9952,
    y2: 27.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2146_13155",
    x1: 15.3409,
    y1: 2.04492,
    x2: 15.3409,
    y2: 18.4767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2146_13155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractor);
export default __webpack_public_path__ + "static/media/tractor.d2acef81.svg";
export { ForwardRef as ReactComponent };